import { render } from "./Maptest.vue?vue&type=template&id=2c09c8a4"
import script from "./Maptest.vue?vue&type=script&lang=js"
export * from "./Maptest.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__